// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"7b9d5566","213":"117e51e9","337":"82c6be29","351":"e4438687","578":"64bd95e3","667":"e027cfce"}[chunkId] + ".chunk.js";
};